import React from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';

import ProductIcon from './ProductIcon';
import { Typography } from '@material-ui/core';


const SELECTED_STYLE = {
  backgroundColor: '#F8F9FD',
};

const SPECIFIC_SELECTED_STYLE = {
  backgroundColor: '#ECF1FD',
};

const styles = theme => ({
  icon: {
    marginRight:0,
  },
  listItemRoot: {
    '&$listItemSelected': SELECTED_STYLE,
    '&$listItemFocusVisible': SELECTED_STYLE,
    '&$listItemFocusVisibleSpecific': SPECIFIC_SELECTED_STYLE,
  },
  listItemSelected: SELECTED_STYLE,
  listItemFocusVisible: SELECTED_STYLE,
  listItemFocusVisibleSpecific: SPECIFIC_SELECTED_STYLE,
  dot: {
    height:8,
    width:8,
  }
})

const ProductListItem = ({
  currentProduct,
  product,
  onClick,
  classes,
  hasRedDot,
  specificSelectedColor
}) => (
  <ListItem 
    button 
    classes={{
      root: classes.listItemRoot,
      selected: specificSelectedColor ? classes.listItemFocusVisibleSpecific : classes.listItemSelected,
      focusVisible: classes.listItemFocusVisible,
    }} 
    onClick={onClick} 
    selected={currentProduct === product.id} 
  > 
    <ListItemIcon className={classes.icon}>
      <ProductIcon 
        product={product} 
      />
    </ListItemIcon>
    <ListItemText 
      secondary={
        hasRedDot 
          ? <Badge classes={{dot: classes.dot}} color="secondary" variant="dot">
              <Typography style={{paddingRight:16}} component="span">{product.name}</Typography>
            </Badge> 
          : <Typography style={{paddingRight:16}}>{product.name}</Typography>
      }  
    />
  </ListItem>
)

export default withStyles(styles) (ProductListItem);



// WEBPACK FOOTER //
// ./src/components/products/ProductListItem.js